<div class="row">
	<div class="col-12">
		<div class="panel">

			<h2>{{ labels().VIEW_PLAN_COMPONENT_TITLE }}</h2>

			<div class="row mt-5">
				<div class="col-6 flex-column">
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PAT_INITIALS }}</div>
						<div>{{plan().patient!.initials}}</div>
					</div>
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PAT_ID }}</div>
						<div>{{plan().patient!.number}}</div>
					</div>
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PAT_GENDER }}</div>
						<div>{{plan().patient!.gender}}</div>
					</div>
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PLAN_ID }}</div>
						@let planNumber = plan().isReceived ? (plan().number | replaceLongLeg) : plan()!.number;
						<div>{{planNumber}}</div>
					</div>
					<div class="data-item">
						<div>
							{{ labels().VIEW_PLAN_COMPONENT_PLAN_CREATION_DATE }}
							<span data-testid="SUBSYS7_VIEW_FORMATDATE_TXT" class="date-format ms-3">{{ dateFormat }}</span>
						</div>
						<div>{{plan().creationDate! | convertDate}}</div>
					</div>
				</div>
				<div class="col-6 flex-column">
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PLAN_TYPE }}</div>
						<div>{{plan().type | planTypeLabel}}</div>
					</div>
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PLAN_SIDE }}</div>
						<div>{{plan().side | anatomicalSideLabel}}</div>
					</div>
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PLAN_STEP }}</div>
						<div>
							{{ plan().isPostOperative ? labels().VIEW_PLAN_COMPONENT_PLAN_STEP_POSTOP :
							labels().VIEW_PLAN_COMPONENT_PLAN_STEP_PREOP}}
						</div>
					</div>
					<div class="data-item">
						<div>{{ labels().VIEW_PLAN_COMPONENT_PLAN_BONE_TYPE }}</div>
						<div>{{plan().boneType | boneTypeLabel }}</div>
					</div>
				</div>
			</div>

		</div>
	</div>

</div>